import { Form, notification } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router";
import { LookupRequest } from "../../../models/lookup-request";
import { useResetPasswordMutation } from "../../../state/agencyApi";
import { buildAgencyRequest } from "../../../state/connect-api";

const useProfile = () => {
  const [form] = Form.useForm();
  const [isChangePassword, setIsChangePassword] = useState<boolean>(false);
  const [isUpdateRecoverInfo, setIsUpdateRecoveryInfo] = useState<boolean>(false);
  const [isUpdateLoginEmail, setIsUpdateLoginEmail] = useState<boolean>(false);
  const [resetPassword, { isLoading: resetPasswordLoading }] = useResetPasswordMutation();
  const navigate = useNavigate();

  const handleChangePassword = async () => {
    const values = await form.validateFields();
    if (values.password !== values.retypePassword) return notification.error({ message: "Password does not match" });

    const lookupRequest: LookupRequest = buildAgencyRequest(localStorage.getItem("LoginId"), "", values.currentPassword, values.password, values.retypePassword, String(true));
    const results = await resetPassword(lookupRequest).unwrap();

    if (results.ERROR[0].ERROR) {
      notification.error({ message: results.ERROR[0].ERROR });
    } else {
      notification.success({ message: "Password reset successfully" });
      localStorage.clear();
      navigate("/login");
    }
  };

  const handleChangeEmail = async () => {
    const values = await form.validateFields();
    notification.warn({ message: "NYI." });
  };

  const handleCancel = async () => {
    form.resetFields();
    form.setFieldsValue({ currentLoginId: localStorage.getItem("LoginId") });
  };

  return {
    form,
    isChangePassword,
    isUpdateLoginEmail,
    isUpdateRecoverInfo,
    handleCancel,
    handleChangeEmail,
    handleChangePassword,
    setIsChangePassword,
    setIsUpdateLoginEmail,
    setIsUpdateRecoveryInfo,
    resetPasswordLoading
  };
};

export default useProfile;
